import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/vendors")({
  staticData: {
    breadcrumb: "Vendors",
  },
  component: () => <Outlet />,
});
